import { useEffect, useState } from 'react'

// Threshold detecting when viewport changes size substantially, most likely due to keyboard extending
const KEYBOARD_EXTENDED_THRESHOLD = 150

// Threshold allowing for minor viewport variance (such as url bar) and retraction of keyboard
const KEYBOARD_RETRACTED_VIEWPORT_VARIANCE = 50

export const useIOSKeyboardFix = () => {
  const [keyboardHeight, setKeyboardHeight] = useState(0)

  // Only run on iOS devices
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && 'visualViewport' in window
  useEffect(() => {
    if (!isIOS) return

    const initialViewportHeight = window.visualViewport!.height

    const handleViewportChange = () => {
      const currentHeight = window.visualViewport!.height
      const heightDifference = initialViewportHeight - currentHeight

      if (heightDifference > KEYBOARD_EXTENDED_THRESHOLD)
        setKeyboardHeight(heightDifference)

      if (heightDifference < KEYBOARD_RETRACTED_VIEWPORT_VARIANCE)
        setKeyboardHeight(0)
    }

    window.visualViewport?.addEventListener('resize', handleViewportChange)

    return () =>
      window.visualViewport?.removeEventListener('resize', handleViewportChange)
  }, [isIOS])

  return { keyboardHeight, isKeyboardOpen: keyboardHeight > 0, isIOS }
}
